import React from "react";
import { connect } from "react-redux";
import {
    selectDayRange,
    selectWeekCount,
    selectChildEventsForParentEventView
} from "../redux/selectors";
import BuildIcon from "@material-ui/icons/Build";
import LocalShippingIcon from "@material-ui/icons/LocalShipping";
import PersonIcon from "@material-ui/icons/Person";
class ParentEventView extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            width: props.event.end - props.event.start
        };
    }

    checkIsVisible = () => {
        if (this.props.event.start > this.props.weekCount * 7 - 1) {
            return false;
        }

        if (this.props.event.end <= 0) {
            return false;
        }
        return true;
    };

    hexToRGB = (hex, alpha) => {
        var r = parseInt(hex.slice(1, 3), 16),
            g = parseInt(hex.slice(3, 5), 16),
            b = parseInt(hex.slice(5, 7), 16);

        if (alpha) {
            return "rgba(" + r + ", " + g + ", " + b + ", " + alpha + ")";
        } else {
            return "rgb(" + r + ", " + g + ", " + b + ")";
        }
    };

    render() {
        const childEvents = this.props.childEvents.events;
        const rowCounts = this.props.childEvents.rowCounts;

        let rowCount = 0;
        if (childEvents.length !== 0) {
            rowCount = childEvents[childEvents.length - 1].row;
        }
        if (this.checkIsVisible() === false) {
            return null;
        }

        const start = this.props.event.start < 1 ? 0 : this.props.event.start;
        const end =
            this.props.event.end > this.props.weekCount * 7
                ? this.props.weekCount * 7
                : this.props.event.end;

        const background = this.hexToRGB(this.props.event.color, 0.85);
        const position = {
            gridColumnStart: start + 1,
            gridColumnEnd: end + 1,
            gridRowStart: this.props.event.row,
            gridRowEnd: this.props.event.row,
            background,
            filter: this.props.selected ? "opacity(80%)" : ""
        };

        if (this.props.showChildren === true) {
            return (
                <div className={`EventView`} style={{ ...position }}>
                    <div className="EventViewTitle">
                        <span>{this.props.event.name}</span>
                    </div>
                </div>
            );
        } else {
            let width = end - start;
            width = width === 0 ? 1 : width;
            const remainingPercent = ((width - 1) / width) * 100;
            const frac = (1 / width) * 100;

            let columns = `20px calc(${frac}% - 20px) repeat(${width - 1}, ${remainingPercent /
                (width - 1)}%)`;

            if (width === 1) {
                columns = `20px calc(100% - 20px)`;
            }

            return (
                <div className={`EventView`} style={{ ...position }}>
                    <div
                        style={{
                            gridTemplateRows: `20% 80%`,
                            gridTemplateColumns: `100%`,
                            width: "100%",
                            height: "100%",
                            display: "grid",
                            overflow: "hidden"
                        }}
                    >
                        <div
                            className="EventViewTitle"
                            style={{
                                gridRowStart: 1,
                                gridRowEnd: 1,
                                gridColumnStart: 1,
                                gridColumnEnd: end - start + 1,
                                overflow: "hidden"
                            }}
                        >
                            <span>{this.props.event.name}</span>
                        </div>
                        <div
                            style={{
                                gridColumnStart: 1,
                                gridColumnEnd: 1,
                                gridRowStart: 2,
                                gridRowEnd: 2,
                                gridTemplateRows: `repeat(${rowCount}, ${100 / rowCount}%)`,
                                gridTemplateColumns: columns,
                                width: "100%",
                                height: "100%",
                                display: "grid",
                                gridGap: "1px",
                                overflow: "hidden",
                                // paddingTop: "2px",
                                paddingRight: "4px",
                                paddingBottom: "4px",
                                background: "rgba(0, 0, 0, 0.5)"
                            }}
                        >
                            <div
                                style={{
                                    gridRowStart: 1,
                                    gridRowEnd: rowCount + 1,
                                    gridColumnStart: 1,
                                    gridColumnEnd: 1
                                    // borderRight: `1px solid ${background}`,
                                    // borderTop: `1px solid ${background}`
                                }}
                            />
                            {rowCounts.employeeRowCount !== 0 && (
                                <div
                                    style={{
                                        gridRowStart: 1,
                                        gridRowEnd: 1,
                                        gridColumnStart: 1,
                                        gridColumnEnd: 1
                                    }}
                                >
                                    <PersonIcon style={{ fontSize: 20, color: "white" }} />
                                </div>
                            )}

                            {rowCounts.machinesRowCount !== 0 && (
                                <div
                                    style={{
                                        gridRowStart: rowCounts.employeeRowCount + 1,
                                        gridRowEnd:
                                            rowCounts.employeeRowCount + rowCounts.machinesRowCount,
                                        gridColumnStart: 1,
                                        gridColumnEnd: 1
                                    }}
                                >
                                    <LocalShippingIcon style={{ fontSize: 20, color: "white" }} />
                                </div>
                            )}
                            {rowCounts.equipmentRowCount !== 0 && (
                                <div
                                    style={{
                                        gridRowStart:
                                            rowCounts.employeeRowCount +
                                            rowCounts.machinesRowCount +
                                            1,
                                        gridRowEnd:
                                            rowCounts.employeeRowCount +
                                            rowCounts.machinesRowCount +
                                            rowCounts.equipmentRowCount,
                                        gridColumnStart: 1,
                                        gridColumnEnd: 1
                                    }}
                                >
                                    <BuildIcon style={{ fontSize: 20, color: "white" }} />
                                </div>
                            )}
                            {childEvents.map((e, i) => {
                                return (
                                    <div
                                        key={i}
                                        style={{
                                            gridRowStart: e.row,
                                            gridRowEnd: e.row,
                                            gridColumnStart: e.start + 2,
                                            gridColumnEnd: e.end + 2,
                                            fontSize: "90%",
                                            background: e.color,
                                            color: "white",
                                            padding: "3px",
                                            overflow: "hidden",
                                            borderRadius: "2px",
                                            boxSizing: "border-box",
                                            border: "1px solid white"
                                        }}
                                    >
                                        {e.name}
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            );
        }
    }
}

export default connect(
    (store, props) => {
        return {
            dayRange: selectDayRange(store),
            weekCount: selectWeekCount(store),
            childEvents: selectChildEventsForParentEventView(props.parentTrackIndex, props.index)(
                store
            )
        };
    },
    {}
)(ParentEventView);
